window.UserIdentity = (function () {

  if (
    window.Shopify &&
    Shopify.country &&
    Shopify.country !== 'US'
  ) {
    return {
      identify: async function () {
        return null;
      }
    };
  }

  const COOKIE_NAME = '_hashed_user_id';
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

  async function hashEmail(email) {
    if (!email || typeof email !== 'string') {
      return null;
    }

    const normalizedEmail = email.trim().toLowerCase();
    const encoder = new TextEncoder();
    const data = encoder.encode(normalizedEmail);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    return hashArray
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  }

  function setCookie(hashedEmail) {
    document.cookie =
      `${COOKIE_NAME}=${hashedEmail}; ` +
      `max-age=${COOKIE_MAX_AGE}; ` +
      `path=/; ` +
      `Secure; ` +
      `SameSite=Lax`;
  }

  function pushToDataLayer(hashedEmail) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'user_identified',
      user_hashed_user_id: hashedEmail
    });
  }

  async function identify(email) {
    try {
      if (!email) return null;

      const hashedEmail = await hashEmail(email);

      if (!hashedEmail) return null;

      setCookie(hashedEmail);
      pushToDataLayer(hashedEmail);

      return hashedEmail;
    } catch (error) {
      console.error('User identity error', error);
      return null;
    }
  }

  return {
    identify
  };
})();